// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var ListSelectionMode;
(function (ListSelectionMode) {
    ListSelectionMode["Auto"] = "auto";
    ListSelectionMode["Default"] = "default";
    ListSelectionMode["Parent"] = "parent";
})(ListSelectionMode || (ListSelectionMode = {}));
